import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { formatCruiseTypeFilterLabel } from 'constants/cruise'

function useCruiseTypeFilterLabel() {
  const intl = useIntl()

  return useCallback((cruiseType?: string): string | undefined => {
    return formatCruiseTypeFilterLabel(intl, cruiseType)
  }, [intl])
}

export default useCruiseTypeFilterLabel
